/**
 * @param $location
 * @param $scope
 * @param $timeout
 * @param {AppConfig} appConfig
 * @param {CurrentDevice} currentDevice
 * @param {DeviceManager} deviceManager
 * @param {DialogService} dialogService
 * @param {LangService} langService
 * @param {NavigationService} navigationService
 * @param {PrivilegesManager} privilegesManager
 * @param {TradingSessionManager} tradingSessionManager
 * @param {UserService} userService
 */
const DeviceCtrl = function (
    $location,
    $scope,
    $timeout,
    appConfig,
    currentDevice,
    deviceManager,
    dialogService,
    langService,
    navigationService,
    privilegesManager,
    tradingSessionManager,
    userService
) {
    navigationService.showNav();

    $scope.errorMessage = null;

    /**
     * @type {Device[]}
     */
    $scope.availableDevices = [];

    /**
     * @type {Device[]}
     */
    $scope.assignedDevices = [];

    /**
     * @type {boolean}
     */
    $scope.showAssignedDevices = false;

    $scope.user = userService;
    $scope.appConfig = appConfig;
    $scope.processingMessage = 'DEVICE_SELECTION.PROCESSING_LOAD';
    $scope.hasPermission = false;

    $scope.doPermissionCheck = () => {
        privilegesManager
            .requirePrivilege('assign_device')
            .then((result) => {
                if (result.granted) {
                    $timeout(() => {
                        $scope.hasPermission = true;
                    });
                }
            });
    };
    $scope.doPermissionCheck();

    $scope.enableShowAssignedDevices = () => {
        $scope.showAssignedDevices = true;
    };

    /**
     * @param {Device} device
     */
    $scope.selectDeviceWithConfirmation = async (device) => {
        let customHtml = '<div>' + langService.getText('DEVICE_SELECTION.ASSIGN_CONFIRMATION', { deviceName: device.name }) + '</div>';

        if (device.guid) {
            customHtml += '<div class="alert alert-danger mt-1 text-base-size">'
                + langService.getText('DEVICE_SELECTION.REASSIGN_CONFIRMATION')
                + '</div>';
        }

        const confirmed = await dialogService.confirm(
            null,
            {
                customHtml,
            }
        );
        if (confirmed) {
            assignDevice(device);
        }
    };

    /**
     * @param {Device} device
     */
    const assignDevice = async (device) => {
        $scope.processingMessage = 'DEVICE_SELECTION.PROCESSING_SELECT';

        if (device.guid) {
            // This device is already assigned. We need to clear its existing guid first.
            await deviceManager.unassignDevice(device.ID);
        }

        deviceManager
            .assignDevice(device.ID)
            .then(async (assignedDevice) => {
                $scope.errorMessage = null;
                if (currentDevice.isSet()) {
                    // Switch to the device's default branch if the currently logged in user has access.
                    if (assignedDevice.defaultBranch) {
                        console.log('Device has default branch. Attempting to switch.', device.defaultBranch.ID);
                        let branchFromCurrentUser = userService.getBranchByID(assignedDevice.defaultBranch.ID);
                        if (branchFromCurrentUser) {
                            console.log('User has access to default branch. Switching', branchFromCurrentUser);
                            userService.changeBranches(
                                branchFromCurrentUser,
                                branchFromCurrentUser
                            );
                        }
                    }

                    // Update the current user on the device.
                    // This makes an API request to set the current user on the device in DB.
                    if (userService.getUserID()) {
                        await deviceManager
                            .setCurrentUser(device.ID, userService.getUserID())
                            .then(() => {})
                            .catch(() => {});
                    }

                    // Go back to index to continue to startup flow.
                    navigationService.viewEposIndex();
                }
            })
            .catch((err) => {
                $scope.processingMessage = '';
                $scope.errorMessage = err.message;
            });
    };

    const loadDevices = () => {
        deviceManager
            .loadDevices()
            .then((devices) => {
                $timeout(() => {
                    $scope.availableDevices = devices.filter((d) => !d.guid);
                    $scope.assignedDevices = devices.filter((d) => !!d.guid);
                });
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                $timeout(() => {
                    $scope.processingMessage = '';
                });
            });
    };

    if (currentDevice.isSet()) {
        // If this page is accessed by changing the URL to /#devices redirect to a more appropriate place
        navigationService.viewEposIndex();
    } else {
        loadDevices();
    }
};

module.exports = DeviceCtrl;
